/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nebyl nalezen žádný účet s tímto odkazem.`
};

const da_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Ingen konto fundet med dette link.`
};

const de_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Kein Konto mit diesem Link gefunden.`
};

const en_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `No account found with this link.`
};

const es_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `No se encontró ninguna cuenta con este enlace.`
};

const fr_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Aucun compte trouvé avec ce lien.`
};

const hu_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nincs fiók ehhez a linkhez.`
};

const it_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nessun account trovato con questo link.`
};

const nl_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Geen account gevonden met deze link.`
};

const pl_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nie znaleziono konta z tym linkiem.`
};

const pt_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Nenhuma conta encontrada com este link.`
};

const sv_account_renew_password_errors_404 = /** @type {(inputs: {}) => string} */ () => {
	return `Inget konto hittades med denna länk.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const account_renew_password_errors_404 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.account_renew_password_errors_404(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("account_renew_password_errors_404", locale)
	if (locale === "cs") return cs_account_renew_password_errors_404(inputs)
	if (locale === "da") return da_account_renew_password_errors_404(inputs)
	if (locale === "de") return de_account_renew_password_errors_404(inputs)
	if (locale === "en") return en_account_renew_password_errors_404(inputs)
	if (locale === "es") return es_account_renew_password_errors_404(inputs)
	if (locale === "fr") return fr_account_renew_password_errors_404(inputs)
	if (locale === "hu") return hu_account_renew_password_errors_404(inputs)
	if (locale === "it") return it_account_renew_password_errors_404(inputs)
	if (locale === "nl") return nl_account_renew_password_errors_404(inputs)
	if (locale === "pl") return pl_account_renew_password_errors_404(inputs)
	if (locale === "pt") return pt_account_renew_password_errors_404(inputs)
	return sv_account_renew_password_errors_404(inputs)
};
export { account_renew_password_errors_404 as "account.renew_password_errors.404" }